const FIRST_PAGE_PATTERN = "\"offset\":0"

const clearPagesFromCache = (queryName, cache) => {
  Object.keys(cache.data.data).forEach((key) => {
    if (key.includes(queryName) && !key.includes(FIRST_PAGE_PATTERN)) {
      cache.data.delete(key)
    }
  })
}

export default clearPagesFromCache
